import React from "react";
import { Box, Typography, Chip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import WarningIcon from "@mui/icons-material/Warning";

const StatusLegend = () => {
  return (
    <Box
      sx={{
        marginTop: "0.5rem",
        marginBottom: "0.5rem",
        marginRight: "0.5rem",
        padding: "0.75rem",
        backgroundColor: "#f8f9fa",
        borderRadius: "0.25rem",
        border: "1px solid #e9ecef",
      }}
    >
      
      <Box sx={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
        {/* Partial Pass */}
        <Box sx={{ display: "grid", gridTemplateColumns: "120px 1fr", columnGap: "1rem", alignItems: "center" }}>
          <Chip
            icon={<WarningIcon sx={{ fontSize: "0.7rem" }} />}
            label="Partial Pass"
            color="info"
            size="small"
            sx={{ 
              fontSize: "0.7rem", 
              height: "24px",
              fontWeight: 500,
              justifySelf: "start",
            }}
          />
          <Typography 
            variant="caption" 
            sx={{ 
              fontSize: "0.7rem", 
              color: "#6c757d",
              lineHeight: 1.4,
              wordBreak: "break-word",
            }}
          >
            Some automated checks need manual validation due to inconsistent results
          </Typography>
        </Box>
        
        {/* Issue */}
        <Box sx={{ display: "grid", gridTemplateColumns: "120px 1fr", columnGap: "1rem", alignItems: "center" }}>
          <Chip
            icon={<WarningIcon sx={{ fontSize: "0.7rem" }} />}
            label="Issues"
            color="warning"
            size="small"
            sx={{ 
              fontSize: "0.7rem", 
              height: "24px",
              fontWeight: 500,
              justifySelf: "start",
            }}
          />
          <Typography 
            variant="caption" 
            sx={{ 
              fontSize: "0.7rem", 
              color: "#6c757d",
              lineHeight: 1.4,
              wordBreak: "break-word",
            }}
          >
            Failed automated checks due to non-compliance configurations
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default StatusLegend;
